<template>
    <v-container >
      <v-card pa-2 >
        <div align="left" class="pa-2">
           Last updated: January 29, 2020
          <h1>TERMS OF SERVICE</h1>
            By using Smooth Talkr("Services"), you are agreeing to these terms.  Please read them carefully.
            <ul>
                <br><li> You may not misuse the Services, for examble by interfering with our Services or accessing them using a method other than the interface and the instructions that we provide. You may use our Services only as permitted by law, including applicable export and re-export control laws and regulations. We may suspend or stop providing our Services to you if you do not comply with our terms or policies or if we are investigating suspected misconduct.</li>
                <br><li> Content that threatens individuals is not allowed on the Services. We also do not allow content that targets an individual with insults based on any atributes including but not necessarly limited to the following: physical traits, age, disability, ethnicity, gender identity, nationality, race, religion, sex, or sexual orientation.</li>
                <br><li> You retain ownership of any intellectual property rights that you hold in content that you upload to our Services. When you publish that content on our Service, you are granting us a worldwide, non-exclusive, royalty-free license (with the right to sublicense) to use, copy, reproduce, process, adapt, modify, publish, transmit, display and distribute such Content in any and all media or distribution methods now known or later developed (for clarity, these rights include, for example, curating, transforming, and translating). This license authorizes us to make your Content available to the rest of the world and to let others do the same.</li>
                <br><li> You represent and warrant that you have all rights necessary to grant the rights granted herein for any content that you publish through the Services. You agree that such Content will not contain material subject to copyright or other proprietary rights, unless you have necessary permission or are otherwise legally entitled to post the material and to grant us the license described above.</li>
                <br><li>We may revise these Terms from time to time. The changes will not be retroactive, and the most current version of the Terms will govern our relationship with you. We will try to notify you of material revisions. By continuing to access or use the Services after those revisions become effective, you agree to be bound by the revised Terms.</li>
            </ul>
        </div>
      </v-card>
    </v-container>
</template>
<script>
export default {
  props: {},
  data () {
    return {
    }
  },
  mounted: function () {
  },
  methods: {
    onClearCash: function () {

    }
  }
}
</script>
<style>
H2 {display: inline;}
H3 {display: inline;}
H4 {display: inline;}
H5 {display: inline;}
H6 {display: inline;}
</style>



// WEBPACK FOOTER //
// src/components/TOS.vue